var fieldNames = {
  "AGENCY": "产品责任机构",
  "BCNSHP": "立标形状",
  "BUISHP": "建筑形状",
  "BOYSHP": "浮标形状",
  "BURDEP": "埋置深度",
  "CALSGN": "呼号",
  "CATAIR": "机场类",
  "CATACH": "锚地类",
  "CATBRG": "桥梁类",
  "CATBUA": "建筑群区类",
  "CATCBL": "电缆类",
  "CATCAN": "渠道类",
  "CATCAM": "方位标志类",
  "CATCHP": "检查站类",
  "CATCOA": "海岸线类",
  "CATCTR": "控制点类",
  "CATCON": "传送装置类",
  "CATCOV": "作用范围类",
  "CATCRN": "起重机类",
  "CATDAM": "水坝类",
  "CATDIS": "距离标志类",
  "CATDOC": "船坞类",
  "CATDPG": "倾废场类",
  "CATFNC": "栅栏类",
  "CATFRY": "轮渡类",
  "CATFIF": "捕鱼设备类",
  "CATFOG": "雾号类",
  "CATFOR": "防御工事类",
  "CATGAT": "门类",
  "CATHAF": "港口设备类",
  "CATHLK": "趸船类",
  "CATICE": "冰类",
  "CATINB": "作业浮标类",
  "CATLND": "地面地带类",
  "CATLMK": "陆标类",
  "CATLAM": "侧面标志类",
  "CATLIT": "灯标类",
  "CATMFA": "海水养殖场类",
  "CATMPA": "军事演习区类",
  "CATMOR": "系泊绞缆设备类",
  "CATNAV": "导航线类",
  "CATOBS": "障碍物类",
  "CATOFP": "海上平台类",
  "CATOLB": "油障类",
  "CATPLE": "木桩类",
  "CATPIL": "引航员登船点类",
  "CATPIP": "管道类",
  "CATPRA": "生产区域类",
  "CATPYL": "塔架类",
  "CATQUA": "数据质量类",
  "CATRAS": "雷达站类",
  "CATRTB": "雷达应答器类",
  "CATROS": "无线电台类",
  "CATTRK": "推荐航线类",
  "CATRSC": "救助站类",
  "CATREA": "限制区类",
  "CATROD": "道路类",
  "CATRUN": "跑道类",
  "CATSEA": "海区类",
  "CATSLC": "岸线建筑物类",
  "CATSIT": "交通信号站类",
  "CATSIW": "告警信号台类",
  "CATSIL": "筒仓、罐类",
  "CATSLO": "斜坡类",
  "CATSCF": "小型船用设备类",
  "CATSPM": "专用标志类",
  "CATTSS": "分道通航制类",
  "CATVEG": "植被类",
  "CATWAT": "紊流类",
  "CATWED": "海草、巨型海藻类",
  "CATWRK": "沉船类",
  "CATZOC": "数据置信度区类",
  "SPACE_": "字符空格",
  "CHARS_": "字符说明",
  "COLOUR": "颜色",
  "COLPAT": "彩色图案",
  "COMCHA": "通信频道",
  "CSIZE_": "罗经花尺寸",
  "CPDATE": "汇编日期",
  "CSCALE": "编辑比例尺",
  "CONDTN": "状态",
  "CONRAD": "雷达可视",
  "CONVIS": "视觉可见",
  "CURVEL": "海流速度",
  "DATEND": "终止日期",
  "DATSTA": "开始日期",
  "DRVAL1": "深度范围值1",
  "DRVAL2": "深度范围值2",
  "DUNITS": "深度单位",
  "ELEVAT": "海拔",
  "ESTRNG": "预计传输范围",
  "EXCLIT": "灯光显示状况",
  "EXPSOU": "水深说明",
  "FUNCTN": "功能",
  "HEIGHT": "高度",
  "HUNITS": "高度、长度单位",
  "HORACC": "水平精度",
  "HORCLR": "水平净空",
  "HORLEN": "水平长度",
  "HORWID": "水平宽度",
  "ICEFAC": "冰况系数",
  "INFORM": "信息",
  "JRSDTN": "管辖区域",
  "JUSTH_": "水平对齐",
  "JUSTV_": "垂直对齐",
  "LIFCAP": "起重能力",
  "LITCHR": "灯质",
  "LITVIS": "灯标能见度",
  "MARSYS": "海上标志体系",
  "MLTYLT": "灯组",
  "NATION": "国籍",
  "NATCON": "建筑结构性质",
  "NATSUR": "表面性质",
  "NATQUA": "表面性质限定术语",
  "NMDATE": "航海通告日期",
  "OBJNAM": "物标名称",
  "ORIENT": "方位",
  "PEREND": "定期终止日期",
  "PERSTA": "定期开始日期",
  "PICREP": "图示显示",
  "PILDST": "引航区域",
  "PRCTRY": "生产国家",
  "PRODCT": "产品",
  "PUBREF": "出版物参考",
  "QUASOU": "水深测量特性",
  "RADWAL": "雷达波长",
  "RADIUS": "半径",
  "RECDAT": "记录日期",
  "RECIND": "记录表示法",
  "RYRMGV": "磁差参考年份",
  "RESTRN": "限制区",
  "SCAMAX": "最大比例尺",
  "SCAMIN": "最小比例尺",
  "SCVAL1": "比例值1",
  "SCVAL2": "比例值2",
  "SECTR1": "扇形界限1",
  "SECTR2": "扇形界限2",
  "SHIPAM": "偏移参数",
  "SIGFRQ": "信号频率",
  "SIGGEN": "信号生成",
  "SIGGRP": "信号组",
  "SIGPER": "信号周期",
  "SIGSEQ": "信号时序",
  "SOUACC": "测深精度",
  "SDISMX": "最大测深间距",
  "SDISMN": "最小测深间距",
  "SORDAT": "数据来源日期",
  "SORIND": "数据来源表示",
  "STATUS": "状况",
  "SURATH": "测量机构",
  "SUREND": "测量结束日期",
  "SURSTA": "测量开始日期",
  "SURTYP": "测量类型",
  "SCALE_": "符号缩放系数",
  "SCODE_": "符号代码",
  "TECSOU": "水深测量技术",
  "TXSTR_": "文本串",
  "TXTDSC": "正文描述",
  "TS_TSP": "潮流通告版值",
  "TS_TSV": "潮流时序值",
  "T_ACWL": "潮汐潮位精度",
  "T_HWLW": "潮汐高低潮值",
  "T_MTOD": "潮汐预报方法",
  "T_THDF": "潮汐潮时与潮高差",
  "T_TINT": "潮汐时间间隔值",
  "T_TSVL": "潮汐时序值",
  "T_VAHC": "潮汐调和分潮值",
  "TIMEND": "终止时间",
  "TIMSTA": "开始时间",
  "TINTS_": "色调",
  "TOPSHP": "顶标、昼标形状",
  "TRAFIC": "交通流",
  "VALACM": "磁差年变率",
  "VALDCO": "等深线值",
  "VALLMA": "局部磁力异常值",
  "VALMAG": "磁差值",
  "VALMXR": "最大作用距离",
  "VALNMR": "标定作用距离",
  "VALSOU": "水深值",
  "VERACC": "垂直精度",
  "VERCLR": "竖向净空",
  "VERCCL": "封闭竖向净空",
  "VERCOP": "开启竖向净空",
  "VERCSA": "安全竖向净空",
  "VERDAT": "垂直基准面",
  "VERLEN": "垂直高度",
  "WATLEV": "水位效应",
  "CAT_TS": "潮流类",
  "PUNITS": "位置精度单位",
  "CLSDEF": "物标定义",
  "CLSNAM": "物标名称",
  "SYMINS": "物标名称",
  "NINFOM": "用国家语言表示的信息",
  "NOBJNM": "用国家语言表示的物标名称",
  "NPLDST": "用国家语言表示的引航区",
  "NTXST_": "用国家语言表示的文本串",
  "NTXTDS": "用国家语言表示的正文",
  "HORDAT": "水平基准面",
  "POSACC": "位置精度",
  "QUAPOS": "位置性质"
}
export default fieldNames
